export interface PaletteEntry {
  name: string;
  utility: string;
  hexLight: string;
  hexDark: string;
}

// Private Cellar palette. Dark (the default theme) is the mockup's :root;
// light is derived from the same family. Keep in sync with design-system.css.
export const SURFACES: PaletteEntry[] = [
  {
    name: "page",
    utility: "bg-page",
    hexLight: "#f3efe8",
    hexDark: "#080706",
  },
  {
    name: "charcoal",
    utility: "bg-charcoal",
    hexLight: "#eae4da",
    hexDark: "#141110",
  },
  {
    name: "charcoal-2",
    utility: "bg-charcoal-2",
    hexLight: "#e3dcd0",
    hexDark: "#1b1715",
  },
  {
    name: "surface",
    utility: "bg-surface",
    hexLight: "#faf8f4",
    hexDark: "#221d19",
  },
  {
    name: "hairline",
    utility: "border-hairline",
    hexLight: "rgba(118,88,37,.28)",
    hexDark: "rgba(201,168,106,.20)",
  },
  {
    name: "hairline-soft",
    utility: "border-hairline-soft",
    hexLight: "rgba(20,17,16,.10)",
    hexDark: "rgba(244,240,233,.09)",
  },
];

export const TEXT: PaletteEntry[] = [
  {
    name: "ink-body",
    utility: "text-ink-body",
    hexLight: "#3a332d",
    hexDark: "#beb4a7",
  },
  {
    name: "ink-display",
    utility: "text-ink-display",
    hexLight: "#141110",
    hexDark: "#f3efe8",
  },
  {
    name: "ink-muted",
    utility: "text-ink-muted",
    hexLight: "#675d53",
    hexDark: "#8b8177",
  },
];

export const SPLASH: PaletteEntry[] = [
  {
    name: "accent",
    utility: "bg-accent / text-accent",
    hexLight: "#765825",
    hexDark: "#c9a86a",
  },
  {
    name: "accent-faded",
    utility: "bg-accent-faded",
    hexLight: "#ede3cf",
    hexDark: "#231d14",
  },
  {
    name: "accent-display",
    utility: "bg-accent-display / text-accent-display",
    hexLight: "#6a4f20",
    hexDark: "#e0c489",
  },
  {
    name: "signal",
    utility: "bg-signal / text-signal",
    hexLight: "#c8a951",
    hexDark: "#c8a951",
  },
  {
    name: "signal-faded",
    utility: "bg-signal-faded",
    hexLight: "#f4ecd9",
    hexDark: "#2a2516",
  },
  {
    name: "signal-display",
    utility: "bg-signal-display / text-signal-display",
    hexLight: "#6e5a1f",
    hexDark: "#e0c579",
  },
  {
    name: "danger",
    utility: "bg-danger / text-danger",
    hexLight: "#a32f2f",
    hexDark: "#c05a52",
  },
  {
    name: "danger-faded",
    utility: "bg-danger-faded",
    hexLight: "#f5e6e2",
    hexDark: "#2e1917",
  },
  {
    name: "danger-display",
    utility: "bg-danger-display / text-danger-display",
    hexLight: "#852727",
    hexDark: "#e0847c",
  },
  {
    name: "bronze",
    utility: "bg-bronze / text-bronze",
    hexLight: "#8c6a3f",
    hexDark: "#8c6a3f",
  },
  {
    name: "bronze-faded",
    utility: "bg-bronze-faded",
    hexLight: "#efe4d6",
    hexDark: "#2a1d13",
  },
  {
    name: "bronze-display",
    utility: "bg-bronze-display / text-bronze-display",
    hexLight: "#6f4726",
    hexDark: "#c29a68",
  },
  {
    name: "burgundy",
    utility: "bg-burgundy / text-burgundy",
    hexLight: "#5a1b22",
    hexDark: "#5a1b22",
  },
  {
    name: "burgundy-faded",
    utility: "bg-burgundy-faded",
    hexLight: "#f1e3e3",
    hexDark: "#2a1418",
  },
  {
    name: "burgundy-display",
    utility: "bg-burgundy-display / text-burgundy-display",
    hexLight: "#58171f",
    hexDark: "#c4707c",
  },
  {
    name: "forest",
    utility: "bg-forest / text-forest",
    hexLight: "#2c4a38",
    hexDark: "#5c8a6e",
  },
  {
    name: "forest-faded",
    utility: "bg-forest-faded",
    hexLight: "#e3eae3",
    hexDark: "#16211a",
  },
  {
    name: "forest-display",
    utility: "bg-forest-display / text-forest-display",
    hexLight: "#22392b",
    hexDark: "#86ae94",
  },
];

export const FONTS = {
  display: "Cormorant Garamond",
  body: "Montserrat",
};
